import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createNotification = async (data) => {
      try {
        const response = await api.create(`/notifications/add`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getNotifications = async () => {
    try {
      const response = await api.get("/notifications/all");

      return [...response].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
    } catch (error) {
      throw error;
    }
  };
  // export const getNotifications = async () => {
  //     try {
  //       const response = await api.get(`/notifications/all`);
  //       return response;
  //     } catch (error) {
  //       throw error;
  //     }
  // };

  export const getNotificationById = async (id) => {
      try {
        const response = await api.get(`/notifications/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateNotification = async (id, status) => {
      try {
        const response = await api.put(`/notifications/update/${id}/status`, {status});
        return response;
      } catch (error) {
        throw error;
      }
  };
